import React, { FC, useEffect, useMemo, useState } from 'react';
import PaginatedReduxTableWithHeader from '../common/PaginatedReduxTableWithHeader';
import { EmptyState } from '../empty_state/EmptyState';
import HyperLink, { ENTITY_TYPE } from '../common/HyperLink';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { PURCHASE_ORDER_LINE_ITEMS_CRUD_ACTION_CREATORS } from '../../actions/purchase_order_line_items_actions';
import { purchaseOrderLineItemsRestCrudThunksForSupplier } from '../../thunks/purchase_order_line_items_thunks';
import PurchaseOrderStatusDisplay from '../purchase_order_status_display/PurchaseOrderStatusDisplay';
import { getPurchaseOrderId, nullSafeGet } from '../../utils/DataAccessUtils';
import { Spin } from 'antd';
import { partCatalogsRestCrudThunksForSupplier } from '../../thunks/part_catalogs_thunks';

const TC_NAME = 'purchaseOrderLineItemsIndex';

const PartCatalogPurchaseOrdersPage: FC<any> = ({
	updateFilters,
	clearAndUpdateFilters,
	purchaseOrderLineItems,
	match,
	fetchPartCatalog,
	catalogLoading,
}): React.ReactElement => {
	const [partCatalog, setPartCatalog] = useState(null);

	useEffect(() => {
		fetchPartCatalog(match.params.id).then((res) => setPartCatalog(res));
	}, [match.params.id, fetchPartCatalog]);

	const partId = useMemo(() => nullSafeGet('partId', partCatalog), [partCatalog]);
	const partEquipmentVendorId = useMemo(
		() => nullSafeGet('partEquipmentVendorId', partCatalog),
		[partCatalog]
	);

	const columns = useMemo(
		() => [
			{
				title: 'PO',
				dataIndex: 'supplierPurchaseOrder',
				render: (_) => (
					<HyperLink
						text={getPurchaseOrderId(_)}
						entityType={ENTITY_TYPE.PURCHASE_ORDER}
						entityId={nullSafeGet('id', _)}
						backLinkText="Back to Part"
					/>
				),
			},
			{
				title: 'Ordered Qty',
				dataIndex: 'partQuantity',
				render: (_) => _ || 0,
			},
			{
				title: 'Received Qty',
				dataIndex: 'partReceivedQuantity',
				render: (_) => _ || 0,
			},
			{
				title: 'Status',
				render: (_, record) => <PurchaseOrderStatusDisplay status={record.status} />,
			},
		],
		[]
	);

	return !partId || catalogLoading ? (
		<div className="flex flex-row justify-center">
			<Spin />
		</div>
	) : (
		<PaginatedReduxTableWithHeader
			targetCollectionName={TC_NAME}
			updateFilters={updateFilters}
			stateSlice={purchaseOrderLineItems}
			clearAndUpdateFilters={clearAndUpdateFilters}
			filterConfig={[]}
			entityCollectionName="purchase_order_line_items"
			tableColumns={columns}
			fetchData={purchaseOrderLineItemsRestCrudThunksForSupplier.read}
			rightActions={null}
			showHeader
			hideFilters
			preAppliedFilters={{ partId, partEquipmentVendorId }}
			emptyState={
				<EmptyState
					graphic={
						<img
							alt="No Data"
							style={{ marginBottom: 8 }}
							src="https://s3.amazonaws.com/mock-data-assets/categories/images/box.svg"
						/>
					}
					headline={'No Purchase Orders found'}
					body={null}
				/>
			}
		/>
	);
};

const mapStateToProps = (state) => ({
	purchaseOrderLineItems: state.purchase_order_line_items,
	partCatalog: state.part_catalogs.detail,
	catalogLoading: state.part_catalogs.fetching,
});

const mapDispatchToProps = (dispatch) => ({
	updateFilters: (filters, targetCollection) =>
		dispatch(
			PURCHASE_ORDER_LINE_ITEMS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)
		),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(
			PURCHASE_ORDER_LINE_ITEMS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(
				filters,
				targetCollectionName
			)
		),
	fetchPartCatalog: (id) => dispatch(partCatalogsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(PartCatalogPurchaseOrdersPage)
);
